import axios from '@/libs/api.request';

export const getWarehouseEntryList = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseEntry/getWarehouseEntryList',
        data: data,
        method: 'post'
    });
};

export const getAgentWarehouseEntryList = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseEntry/getAgentWarehouseEntryList',
        data: data,
        method: 'post'
    });
};

export const getWarehouseEntryFullList = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseEntry/getWarehouseEntryFullList',
        data: data,
        method: 'post'
    });
};

export const getAgentWarehouseEntryFullList = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseEntry/getAgentWarehouseEntryFullList',
        data: data,
        method: 'post'
    });
};


export const getWarehouseTransformList = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseEntry/getWarehouseTransformList',
        data: data,
        method: 'post'
    });
};

export const transformWarehouseEntry = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseEntry/transformWarehouseEntry',
        data: data,
        method: 'post'
    });
};

export const transformWarehouseEntryToPre = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseEntry/transformWarehouseEntryToPre',
        data: data,
        method: 'post'
    });
};

export const saveWarehouseEntry = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseEntry/saveWarehouseEntry',
        data: data,
        method: 'post'
    });
};

export const importWarehouseEntry = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseEntry/importWarehouseEntry',
        data: data,
        method: 'post'
    });
};

export const saveWarehouseNegativeEntry = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseEntry/saveWarehouseNegativeEntry',
        data: data,
        method: 'post'
    });
};


export const saveAgentWarehouseEntry = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseEntry/saveAgentWarehouseEntry',
        data: data,
        method: 'post'
    });
};

export const getWarehouseEntryDetail = warehouseEntryRecordUuid => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseEntry/getWarehouseEntryDetail',
        data: { warehouseEntryRecordUuid },
        method: 'post'
    });
};
export const withdrawPreSaleWarehouseEntry = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseEntry/withdrawPreSaleWarehouseEntry',
        data: data,
        method: 'post'
    });
};

export const approvalPreSaleWarehouseEntry = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseEntry/approvalPreSaleWarehouseEntry',
        data: data,
        method: 'post'
    });
};

export const getCurSaleWarehouseEntryList = data => {
    return axios.request({
        url: 'api/warehouseManagement/curSaleWarehouseEntry/getCurSaleWarehouseEntryList',
        data: data,
        method: 'post'
    });
};

export const getCurSaleAgentWarehouseEntryList = data => {
    return axios.request({
        url: 'api/warehouseManagement/curSaleWarehouseEntry/getCurSaleAgentWarehouseEntryList',
        data: data,
        method: 'post'
    });
};


export const getCurSaleWarehouseEntryFullList = data => {
    return axios.request({
        url: 'api/warehouseManagement/curSaleWarehouseEntry/getCurSaleWarehouseEntryFullList',
        data: data,
        method: 'post'
    });
};

export const getCurSaleAgentWarehouseEntryFullList = data => {
    return axios.request({
        url: 'api/warehouseManagement/curSaleWarehouseEntry/getCurSaleAgentWarehouseEntryFullList',
        data: data,
        method: 'post'
    });
};

export const saveCurSaleWarehouseEntry = data => {
    return axios.request({
        url: 'api/warehouseManagement/curSaleWarehouseEntry/saveCurSaleWarehouseEntry',
        data: data,
        method: 'post'
    });
};

export const importCurSaleWarehouseEntry = data => {
    return axios.request({
        url: 'api/warehouseManagement/curSaleWarehouseEntry/importCurSaleWarehouseEntry',
        data: data,
        method: 'post'
    });
};

export const saveCurSaleWarehouseNegativeEntry = data => {
    return axios.request({
        url: 'api/warehouseManagement/curSaleWarehouseEntry/saveCurSaleWarehouseNegativeEntry',
        data: data,
        method: 'post'
    });
};

export const saveCurSaleAgentWarehouseEntry = data => {
    return axios.request({
        url: 'api/warehouseManagement/curSaleWarehouseEntry/saveCurSaleAgentWarehouseEntry',
        data: data,
        method: 'post'
    });
};

export const withdrawCurSaleWarehouseEntry = data => {
    return axios.request({
        url: 'api/warehouseManagement/curSaleWarehouseEntry/withdrawCurSaleWarehouseEntry',
        data: data,
        method: 'post'
    });
};

export const approvalCurSaleWarehouseEntry = data => {
    return axios.request({
        url: 'api/warehouseManagement/curSaleWarehouseEntry/approvalCurSaleWarehouseEntry',
        data: data,
        method: 'post'
    });
};

export const getCurSaleWarehouseEntryDetail = warehouseEntryRecordUuid => {
    return axios.request({
        url: 'api/warehouseManagement/curSaleWarehouseEntry/getCurSaleWarehouseEntryDetail',
        data: { warehouseEntryRecordUuid },
        method: 'post'
    });
};

export const getWarehouseForwardEntryList = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseForwardEntry/getWarehouseForwardEntryList',
        data: data,
        method: 'post'
    });
};

export const saveWarehouseForwardEntry = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseForwardEntry/saveWarehouseForwardEntry',
        data: data,
        method: 'post'
    });
};

export const getWarehouseForwardEntryDetail = warehouseForwardEntryRecordUuid => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseForwardEntry/getWarehouseForwardEntryDetail',
        data: { warehouseForwardEntryRecordUuid },
        method: 'post'
    });
};

export const submitWarehouseForwardEntryTrans = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseForwardEntry/submitWarehouseForwardEntryTrans',
        data: data,
        method: 'post'
    });
};
